var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 12.709C1.25 6.77192 6.06294 1.95898 12 1.95898C17.9371 1.95898 22.75 6.77192 22.75 12.709C22.75 18.646 17.9371 23.459 12 23.459C6.06294 23.459 1.25 18.646 1.25 12.709ZM12 3.45898C6.89136 3.45898 2.75 7.60035 2.75 12.709C2.75 17.8176 6.89136 21.959 12 21.959C17.1086 21.959 21.25 17.8176 21.25 12.709C21.25 7.60035 17.1086 3.45898 12 3.45898Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 9.70898C8.75 7.91407 10.2051 6.45898 12 6.45898C13.7949 6.45898 15.25 7.91407 15.25 9.70898C15.25 11.5039 13.7949 12.959 12 12.959C10.2051 12.959 8.75 11.5039 8.75 9.70898ZM12 7.95898C11.0335 7.95898 10.25 8.7425 10.25 9.70898C10.25 10.6755 11.0335 11.459 12 11.459C12.9665 11.459 13.75 10.6755 13.75 9.70898C13.75 8.7425 12.9665 7.95898 12 7.95898Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99977 15.959C7.74825 15.959 5.90517 17.7102 5.75914 19.9243C5.73189 20.3377 5.37473 20.6506 4.96141 20.6234C4.5481 20.5961 4.23514 20.2389 4.2624 19.8256C4.46007 16.8284 6.95289 14.459 9.99977 14.459H13.9998C17.0426 14.459 19.5329 16.8221 19.7364 19.8137C19.7645 20.227 19.4523 20.5848 19.039 20.6129C18.6258 20.641 18.268 20.3288 18.2398 19.9155C18.0895 17.7056 16.2483 15.959 13.9998 15.959H9.99977Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeSm);
export default __webpack_public_path__ + "static/media/me-sm.2702c8ce.svg";
export { ForwardRef as ReactComponent };